/** PKCE helpers (RFC 7636, S256) for the native Facebook login through the system browser (2026-09-18).
 * Pure functions over the Web Crypto API so they can be unit-tested with a known vector. */
export function base64Url(bytes: ArrayBuffer | Uint8Array): string {
  const arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let s = '';
  for (let i = 0; i < arr.length; i++) s += String.fromCharCode(arr[i]);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function randomVerifier(cryptoObj: Crypto = crypto): string {
  const bytes = new Uint8Array(32);
  cryptoObj.getRandomValues(bytes);
  return base64Url(bytes);   // 43 chars from the unreserved set
}

export async function challengeFor(verifier: string, subtle: SubtleCrypto = crypto.subtle): Promise<string> {
  // The verifier is ASCII (unreserved set), so a byte-per-char encoding needs no TextEncoder (absent in jsdom).
  const bytes = Uint8Array.from(verifier, (c) => c.charCodeAt(0) & 0xff);
  const digest = await subtle.digest('SHA-256', bytes);
  return base64Url(digest);
}
